import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { initialize } from 'redux-form';
import { NewContractForm, PageHeader, Stepper } from 'components';
import { LLTextField } from 'components/FormElements';
import { AppLayout } from 'containers';
import { loadFacebookPixels, loadFacebookAdAccount, changeFacebookPixelVerifyUrl } from 'redux/modules/ads';
var FacebookPixelSetup = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    user: state.auth.user,
    organization: state.organization.current,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    facebookPixel: state.ads.facebookPixels && state.ads.facebookPixels.length ? state.ads.facebookPixels[0] : null,
    pixelVerifyUrl: state.ads.facebookPixelVerifyUrl
  };
}, {
  loadFacebookPixels: loadFacebookPixels,
  loadFacebookAdAccount: loadFacebookAdAccount,
  changeFacebookPixelVerifyUrl: changeFacebookPixelVerifyUrl
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(FacebookPixelSetup, _Component);

  var _super = _createSuper(FacebookPixelSetup);

  function FacebookPixelSetup() {
    _classCallCheck(this, FacebookPixelSetup);

    return _super.apply(this, arguments);
  }

  _createClass(FacebookPixelSetup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      this.props.changeFacebookPixelVerifyUrl('');
      var p = Promise.resolve({
        data: this.props.adAccount
      });

      if (!this.props.adAccount[this.props.organization.id]) {
        p = this.props.loadFacebookAdAccount(this.props.organization.id);
      }

      p.then(function (_ref) {
        var adAccount = _ref.data;
        return _this.props.loadFacebookPixels(_this.props.organization.id, adAccount.socialAccountId);
      })["catch"](function (err) {
        return console.error(err);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var installInstructions = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.props.step !== 3 && /*#__PURE__*/React.createElement("p", null, "Before you can use your Facebook pixel, you must install some code snippets on your website. This code sends data back to Facebook so you can measure activity and create smarter advertising based on that activity."))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement(Stepper, {
        steps: [{
          label: 'Install Pixel Code'
        }, {
          label: 'Check Pixel Status'
        }, {
          label: 'All set!'
        }],
        currentStep: this.props.step,
        clickableSteps: false
      }))), this.props.step === 1 && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8 col-xs-offset-2"
      }, /*#__PURE__*/React.createElement("h2", null, "Locate the header code for your website."), /*#__PURE__*/React.createElement("p", null, "You must install the pixel code into the header code of every page of your website. This lets you get data about all page views on your website, to establish a baseline for measuring specific events."))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8 col-xs-offset-2"
      }, /*#__PURE__*/React.createElement("h2", null, "Copy the entire pixel code and paste it in the website header."), /*#__PURE__*/React.createElement("p", null, "Paste the following code at the bottom of the header section, just above the ", '</head>', " tag."))), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          minHeight: 400
        }
      }, this.props.facebookPixel ? /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8 col-xs-offset-2",
        style: {
          overflow: 'scroll',
          padding: 4,
          backgroundColor: 'rgb(239, 239, 239)',
          borderRadius: 6,
          border: '2px solid rgb(233, 233, 233)'
        }
      }, /*#__PURE__*/React.createElement("pre", null, this.props.facebookPixel.code)) : /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8 col-xs-offset-2"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-spinner fa-spin"
      }), " Loading..."))), this.props.step === 2 && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8 col-xs-offset-2"
      }, /*#__PURE__*/React.createElement("h2", null, "Verify Pixel Installation"), /*#__PURE__*/React.createElement("p", null, "Enter the URL of the page that contains the code from the previous step, and we will verify that it is functioning properly."))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8 col-xs-offset-2"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        fullWidth: true,
        hintText: "http://www.example.com/",
        floatingLabelText: "Your website URL",
        onChange: function onChange(e, val) {
          return _this2.props.changeFacebookPixelVerifyUrl(val);
        },
        value: this.props.pixelVerifyUrl
      }), !!this.props.error && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "It doesn't seem like the tracking code is properly installed at this URL.")))), this.props.step === 3 && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8 col-xs-offset-2"
      }, /*#__PURE__*/React.createElement("p", null, "Your Facebook Tracking Pixel has been installed successfully. Facebook will now automatically optimize Website Click ad campaigns using data from this pixel.")))));
      return /*#__PURE__*/React.createElement("div", null, installInstructions);
    }
  }]);

  return FacebookPixelSetup;
}(Component), _defineProperty(_class2, "propTypes", {}), _temp)) || _class);
export { FacebookPixelSetup as default };